import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

let sendApprove = function ({ params, sendApprove, dispatch, dispatchType }) {
  let filterIndexRows = {}
  let row = 0
  let approveRow = 0
  let rejectRow = 0
  let dataRows = params.dataRows
  let codappr = params.codappr
  let dteappr = params.dteappr

  for (var i = 0; i < dataRows.length; i++) {
    if ((typeof dataRows[i].flgStaappr !== 'undefined' && dataRows[i].flgStaappr !== 'P' && dataRows[i].flgStaappr.trim() !== '') || dataRows[i].flg === 'edit') {
      row++
      if (dataRows[i].flgStaappr === 'A') {
        approveRow++
      } else if (dataRows[i].flgStaappr === 'N') {
        rejectRow++
      }
      filterIndexRows[row - 1] = {
        p_staappr: (typeof dataRows[i].flgStaappr !== 'undefined') ? dataRows[i].flgStaappr : '',
        p_numappl: (typeof dataRows[i].numappl !== 'undefined') ? dataRows[i].numappl : '',
        p_numreql: (typeof dataRows[i].numreql !== 'undefined') ? dataRows[i].numreql : '',
        p_codpos1: (typeof dataRows[i].codpos1 !== 'undefined') ? dataRows[i].codpos1 : '',
        p_codposl: (typeof dataRows[i].codposl !== 'undefined') ? dataRows[i].codposl : '',
        p_statappl: (typeof dataRows[i].statappl !== 'undefined') ? dataRows[i].statappl : '',
        p_dteappoi: (typeof dataRows[i].dteappoi.replace(/\//g, '') !== 'undefined') ? dataRows[i].dteappoi.replace(/\//g, '') : '',
        p_codappr: (typeof codappr !== 'undefined') ? codappr : '',
        p_codrcord: (typeof codappr !== 'undefined') ? codappr : '',
        p_dteappr: (typeof dteappr.replace(/\//g, '') !== 'undefined') ? dteappr.replace(/\//g, '') : ''
      }
    }
  }
  if (row > 0) {
    let domRemark = constLabels('msgConfirmSave')
    if (approveRow > 0 || rejectRow > 0) {
      domRemark = ''
      let domRemarkApprove = '<textarea id="remark-approve" class="form-control"></textarea>'
      let domRemarkReject = '<textarea id="remark-reject" class="form-control"></textarea>'
      domRemark += '<div class="swal-approve-remark">'
      domRemark += '  <div class="content-header">'
      domRemark += (approveRow > 0) ? '<div class="item-header">' + 'Remark for Approve' + '</div>' + domRemarkApprove : ''
      domRemark += (rejectRow > 0) ? '<div class="item-header">' + 'Remark for Reject' + '</div>' + domRemarkReject : ''
      domRemark += '  </div>'
      domRemark += '  <div class="content-summary text-skin">'
      domRemark += (approveRow > 0) ? '<div class="item-summary">' + 'No. of Approved' + ' ' + approveRow + ' ' + 'records' + '</div>' : ''
      domRemark += (rejectRow > 0) ? '<div class="item-summary">' + 'No. of Rejected' + ' ' + rejectRow + ' ' + 'records' + '</div>' : ''
      domRemark += '  </div>'
      domRemark += '</div>'
    }
    swal({
      title: constLabels('confirmTitle'),
      text: domRemark,
      showCancelButton: true,
      closeOnConfirm: false,
      closeOnCancel: true,
      html: true
    },
    function (isConfirm) {
      if (isConfirm) {
        let sendParams = {
          param_json: JSON.stringify(filterIndexRows),
          remarkApprove: (approveRow > 0) ? document.getElementById('remark-approve').value : '',
          remarkReject: (rejectRow > 0) ? document.getElementById('remark-reject').value : ''
        }
        swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
        sendApprove(sendParams)
          .then((response) => {
            const data = JSON.parse(response.request.response)
            swal({
              title: '', text: data.response, html: true, type: 'success'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
            dispatch(dispatchType, params.searchIndex)
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
      }
    })
  } else {
    swal({
      title: 'Confirmation',
      text: 'Please select at least 1 record.'
    })
  }
}

export { sendApprove }



// WEBPACK FOOTER //
// ./src/components/hrms27u/sendApproveHrms27u.js